import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {WebSocketSubject} from "rxjs/webSocket";
import {WsService} from "./shared/services/ws.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'eyes2';


  constructor(private translate: TranslateService) {
    const selectedLanguage = localStorage.getItem('eyesUserLocale') || 'en';
    translate.setDefaultLang(selectedLanguage);
    translate.use(selectedLanguage);
    if (!selectedLanguage) localStorage.setItem('eyesUserLocale', 'de');
  }

  ngOnInit() {

  }

}
